import React from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import NavBar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import Home from "../Pages/Home";
import AboutUsPage from "../Pages/AboutUsPage";
import ContactUs from "../Pages/ContactUs";
import KitchenPage from "../Pages/KitchenPage";
import BathroomPage from "../Pages/BathroomPage";
import SpecialConstructionsPage from "../Pages/SpecialConstructionsPage";
import FloorPage from "../Pages/FloorPage";
import LivingRoomPage from "../Pages/LivingRoomPage";
import LightingPage from "../Pages/LightingPage";
import LandingPage from "../Pages/LandingPage";
import VideoSectionPage from "../Pages/VideoSectionPage";
import ServicesPage from "../Pages/ServicesPage";
import ProjectsPage from "../Pages/ProjectsPage";
import ReconstructionsPage from "../Pages/ReconstructionsPage";
import SmartHomePage from "../Pages/SmartHomePage";
import ExteriorSpacesPage from "../Pages/ExteriorSpacesPage";
import BedroomsPage from "../Pages/BedroomsPage";
import AluminumFramesPage from "../Pages/AluminumFramesPage";
import TermsOfUsePage from "../Pages/TermsOfUse";
import PrivacyPolicyPage from "../Pages/PrivacyPolicyPage";
import TestimonialsPage from "../Pages/TestimonialsPage";

function PathAwareApp() {
    const location = useLocation();
    const isLandingPage = location.pathname === '/';

    return (
        <>
            {!isLandingPage && <NavBar />}
            <main className={location.pathname === '/' ? 'landing-page' : ''}>
                <Routes>
                    <Route path='/' element={<LandingPage />} />
                    <Route path='/home' element={<Home />} />
                    <Route path='/company' element={<AboutUsPage />} />
                    <Route path='/terms-of-use' element={<TermsOfUsePage />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
                    <Route path='/contact' element={<ContactUs />} />
                    <Route path='/services' element={<ServicesPage />} />
                    <Route path='/testimonials' element={<TestimonialsPage />} />
                    <Route path='/services/complete-renovations' element={<ReconstructionsPage />} />
                    <Route path='/services/smart-home' element={<SmartHomePage />} />
                    <Route path='/services/exterior-spaces' element={<ExteriorSpacesPage />} />
                    <Route path='/services/bedrooms' element={<BedroomsPage />} />
                    <Route path='/services/kitchens' element={<KitchenPage />} />
                    <Route path='/services/bathrooms' element={<BathroomPage />} />
                    <Route path='/services/special-constructions' element={<SpecialConstructionsPage />} />
                    <Route path='/services/floor' element={<FloorPage />} />
                    <Route path='/services/living-rooms' element={<LivingRoomPage />} />
                    <Route path='/services/aluminum-frames' element={<AluminumFramesPage />} />
                    <Route path='/services/lighting' element={<LightingPage />} />
                    <Route path='/projects' element={<ProjectsPage />} />
                    <Route path='/video-section' element={<VideoSectionPage />} />
                </Routes>
            </main>
            {!isLandingPage && <Footer />}
        </>
    );
}

export default PathAwareApp;
